import React from 'react'
import _ from "underscore";
import util from "../../../../../../../utils/es5Utils";

export default function Charts  (props) {
    const widgets = util.widgetsOfType(props.context, 'chart');
    const newProps = Object.assign({}, props, { widgets });
    const childComponents = _.values(props.childComponents).map((Component, id) => <Component.component { ...newProps } key={id} />);

    if (widgets.length > 0 && childComponents.length > 0) {
        return [<label key="chart" text={"Charts"} />, ...childComponents]
    }

    return null;
}
